import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, inr } from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" }) : "—");

const StatusBtn = ({ label, onClick, id }) => (
  <button data-testid={id} onClick={onClick} className="rounded-full border border-white/15 px-3 py-1 text-xs hover:border-[#FFEF00] hover:text-[#FFEF00] transition-colors">{label}</button>
);

const BookingRow = ({ b, update }) => (
  <tr className="border-b border-white/5 align-top" data-testid={`admin-booking-${b.code}`}>
    <td className="py-3 pr-4 font-mono text-[#FFEF00]">{b.code}</td>
    <td className="py-3 pr-4">{b.title}<div className="text-xs text-slate-400">{b.location}</div></td>
    <td className="py-3 pr-4">{b.date ? `${b.date} ${b.slot}` : "—"}<div className="text-xs text-slate-400">{b.guests} guest(s)</div></td>
    <td className="py-3 pr-4">{b.name}<div className="text-xs text-slate-400">{b.phone} · {b.email}</div></td>
    <td className="py-3 pr-4 font-semibold">{inr(b.total)}</td>
    <td className="py-3 pr-4"><span className={b.payment_status === "paid" ? "text-emerald-400" : "text-amber-300"}>{b.payment_status}</span></td>
    <td className="py-3">{b.payment_status !== "paid" && <StatusBtn id={`mark-paid-${b.code}`} label="Mark paid" onClick={() => update("bookings", b.id, "paid")} />}</td>
  </tr>
);

const EnquiryRow = ({ e, update }) => (
  <tr className="border-b border-white/5 align-top" data-testid={`admin-enquiry-${e.id}`}>
    <td className="py-3 pr-4 capitalize text-[#14C3F7]">{e.kind}</td>
    <td className="py-3 pr-4">{e.name}<div className="text-xs text-slate-400">{e.phone}{e.email ? ` · ${e.email}` : ""}</div></td>
    <td className="py-3 pr-4">{e.city || "—"}<div className="text-xs text-slate-400">{e.guests ? `${e.guests} guests` : ""} {e.event_date || ""}</div></td>
    <td className="py-3 pr-4 max-w-xs text-slate-300">{e.message || "—"}</td>
    <td className="py-3 pr-4 text-xs text-slate-400">{fmt(e.created_at)}</td>
    <td className="py-3 pr-4">{e.status}</td>
    <td className="py-3">{e.status !== "contacted" && <StatusBtn id={`mark-contacted-${e.id}`} label="Mark contacted" onClick={() => update("enquiries", e.id, "contacted")} />}</td>
  </tr>
);

export const AdminTables = () => {
  const [tab, setTab] = useState("bookings");
  const [bookings, setBookings] = useState([]);
  const [enquiries, setEnquiries] = useState([]);
  const load = () => {
    api.get("/admin/bookings").then((r) => setBookings(Array.isArray(r.data) ? r.data : [])).catch(() => {});
    api.get("/admin/enquiries").then((r) => setEnquiries(Array.isArray(r.data) ? r.data : [])).catch(() => {});
  };
  useEffect(() => { load(); }, []);
  const update = async (col, id, status) => {
    try { await api.patch(`/admin/${col}/${id}`, { status }); toast.success("Updated"); load(); } catch (err) { toast.error(errMsg(err)); }
  };
  const heads = tab === "bookings" ? ["Code", "Item", "When", "Customer", "Amount", "Payment", ""] : ["Type", "Contact", "Details", "Message", "Received", "Status", ""];

  return (
    <div className="mt-10">
      <div className="flex gap-2">
        {[["bookings", `Bookings (${bookings.length})`], ["enquiries", `Enquiries (${enquiries.length})`]].map(([k, l]) => (
          <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)} className={`rounded-full px-5 py-2.5 text-sm font-semibold border-2 ${tab === k ? "bg-[#FFEF00] text-black border-black" : "border-white/15"}`}>{l}</button>
        ))}
      </div>
      <div className="mt-6 overflow-x-auto rounded-[22px] border border-white/10 bg-[#0E101D] p-5">
        <table className="w-full text-sm min-w-[900px]">
          <thead><tr className="text-left font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 border-b border-white/10">{heads.map((h, i) => <th key={i} className="pb-3 pr-4 font-normal">{h}</th>)}</tr></thead>
          <tbody>
            {tab === "bookings" ? bookings.map((b) => <BookingRow key={b.id} b={b} update={update} />) : enquiries.map((e) => <EnquiryRow key={e.id} e={e} update={update} />)}
          </tbody>
        </table>
        {(tab === "bookings" ? bookings : enquiries).length === 0 && <p className="py-8 text-center text-slate-400" data-testid="admin-empty">Nothing here yet.</p>}
      </div>
    </div>
  );
};
